// /pages/teacher/Referral.jsx
import React from 'react';

export default function Referral() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold text-indigo-600">Referral Program</h1>
      <p className="mt-2">Share your referral code with others and earn rewards!</p>
    </div>
  );
}
